/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, OptionsFilter, Select } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconLicense, IconRefresh } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { ContractSearchResponseType } from '../../../models/core/contracts.type';
import contractsService from '../../../services/core/contracts.service';
import theme from '../../../theme';
import { SessionStorageKey } from '../../../utils/constants.utils';
import { transformComboBoxGroupDataFromV5toV7 } from '../../../utils/mantine.utils';
import ProfileCardLink from '../ProfileCardLink/ProfileCardLink';
import { ContractStatusEnum } from '../../../business/contracts/status';

type FormViewProps = {
  label: string;
  description: string | null;
  formItem: any;
  showProposal: boolean;
  idsToBeDisabled: number[];
  disabled: boolean;
  callback(item: ContractSearchResponseType | null): void;
  zIndex: number;
  useCache: boolean;
};

export default function ContractPicker(props: FormViewProps) {
  const [data, setData] = useState<ContractSearchResponseType[]>([]);
  const [loading, setLoading] = useState(false);

  const confirmActionResult = (item: ContractSearchResponseType | null, confirmed: boolean) => {
    if (!confirmed) {
      return;
    }
    props.callback(item);
  };

  const loadData = async () => {
    try {
      setLoading(true);
      const result = await contractsService.list();
      setData(
        result.filter(
          (x) =>
            ![
              ContractStatusEnum.Cancelado,
              ContractStatusEnum.Finalizado,
              ContractStatusEnum.Substituido,
            ].includes(x.codigoContratoStatus)
        )
      );
      sessionStorage.setItem(SessionStorageKey.ContractSearch, JSON.stringify(result));
    } catch (error: any) {
      showNotification({
        title: 'Contratos',
        message: error?.isBusinessException ? error.description : 'Não foi possível carregar os contratos.',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.useCache) {
      const cacheResult = JSON.parse(
        sessionStorage.getItem(SessionStorageKey.ContractSearch) || '[]'
      ) as ContractSearchResponseType[];

      if (cacheResult.length > 0) {
        setData(
          cacheResult.filter((x) =>
            [ContractStatusEnum.AguardandoInicio, ContractStatusEnum.EmAndamento].includes(
              x.codigoContratoStatus
            )
          )
        );
      }
    } else {
      loadData();
    }
  }, []);

  const handleRefresh = () => {
    loadData();
  };

  const optionsFilter: OptionsFilter = ({ options, search }) => {
    if (search.trim().length === 0) {
      return options;
    }

    const filteredData = data
      .filter((x) => {
        const value = `${x.idContrato}|${x.idProposta}|${x.contratoStatus}|${x.clienteNomeFantasia || ''}|${
          x.clienteRazaoSocial || ''
        }|${x.clienteCNPJ || ''}|${x.clienteNome || ''}|${x.clienteCPF || ''}`;
        return value.toLowerCase().includes(search.toLowerCase());
      })
      .map((y) => y.idContrato.toString());

    const filteredOptions = [];
    for (const option of options) {
      const items = (option as any).items.filter((x: any) => filteredData.includes(x.value));
      if (items.length > 0) {
        filteredOptions.push({
          ...option,
          items,
        });
      }
    }
    return filteredOptions;
  };

  return (
    <Group grow preventGrowOverflow={false} wrap="nowrap">
      <Select
        key={`contract-picker_${props.formItem.value?.toString()}`}
        leftSection={<IconLicense size={15} />}
        label={props.label}
        description={props.description || null}
        placeholder="Selecione..."
        data={transformComboBoxGroupDataFromV5toV7(
          data.map((x) => {
            return {
              label: `# ${x.idContrato} - ${
                x.clienteNomeFantasia || x.clienteRazaoSocial || x.clienteNome || ''
              }`,
              value: x.idContrato.toString(),
              disabled: props.idsToBeDisabled.includes(x.idContrato),
              group: x.clienteNomeFantasia || x.clienteRazaoSocial || x.clienteNome || 'Cliente',
            };
          })
        )}
        // clearable
        searchable
        filter={optionsFilter}
        disabled={props.disabled || loading}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderOption={({ option, checked }) => {
          const row = data.find((x) => x.idContrato.toString() === option.value)!;
          return (
            <Group>
              <ProfileCardLink
                id={row.idContrato.toString()}
                name={`Contrato # ${row.idContrato}`}
                nameSize="sm"
                description={`${row.contratoStatus}`}
                descriptionSize="xs"
                showLink={false}
              />
              {props.showProposal && (
                <ProfileCardLink
                  id={row.idProposta.toString()}
                  name="Proposta"
                  nameSize="sm"
                  description={`# ${row.idProposta}`}
                  descriptionSize="xs"
                  showLink={false}
                />
              )}
              {/* <ProfileCardLink
                id={row.idCliente.toString()}
                name={row.clienteNomeFantasia || row.clienteRazaoSocial || '-'}
                nameSize="sm"
                description={row.clienteNomeFantasia ? row.clienteRazaoSocial : row.clienteCNPJ}
                descriptionSize="xs"
                linkPrefix="entities"
                showLink
              /> */}
            </Group>
          );
        }}
        required
        {...props.formItem}
        value={props.formItem.value?.toString()}
        onOptionSubmit={(value: string) => {
          confirmActionResult(data.find((x) => x.idContrato.toString() === value) || null, true);
        }}
        comboboxProps={{ zIndex: props.zIndex + 1 }}
      />
      <ActionIcon
        style={{ marginLeft: -10, marginTop: props.description ? 40 : 20, maxWidth: 15 }}
        radius="sm"
        color="primary"
        variant="outline"
        onClick={handleRefresh}
        disabled={props.disabled || loading}
        loading={loading}
      >
        <IconRefresh size={15} color={theme?.colors?.primary?.[6]} />
      </ActionIcon>
    </Group>
  );
}
